import { useContext, useMemo } from "react";
import { Outlet } from "react-router";

import { AppContext } from "App";
import WorkspaceContainer from "components/Workspaces/WorkspaceContainer";

import NavigationMenu from "../NavigationMenu";
import ErrorPanel from "./ErrorPanel";

export default function RouteLayout() {
  const { globalState } = useContext(AppContext);

  // Memoize NavigationMenu based on dependencies, similar to NavigationRoutes
  const navigationMenu = useMemo(() => {
    return <NavigationMenu />;
  }, [globalState.user_role, globalState.producer_token, globalState.agent_token]);

  return (
    <WorkspaceContainer navMenu={navigationMenu}>
      <Outlet />
    </WorkspaceContainer>
  );
}

export function RouteErrorLayout({ errorTitle = "Error" }) {
  const { globalState } = useContext(AppContext);
  const navigationMenu = useMemo(() => {
    return <NavigationMenu />;
  }, [globalState.user_role, globalState.producer_token, globalState.agent_token]);

  return (
    <WorkspaceContainer navMenu={navigationMenu}>
      <ErrorPanel title={errorTitle} />
    </WorkspaceContainer>
  );
}
